/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll(
    ".wp-block-scd-block-image[data-animation-type='scale']",
  );

  if (elements.length === 0) {
    return;
  }

  elements.forEach(async (element) => {
    const { default: gsap } = await import("gsap");
    const { default: ScrollTrigger } = await import("gsap/ScrollTrigger");

    gsap.registerPlugin(ScrollTrigger);

    // 画面下のときは幅80%ほど、画面上のときは100%になるようにアニメーションする
    gsap.fromTo(
      element,
      {
        clipPath: "inset(15% round 24px)",
      },
      {
        clipPath: "inset(0% round 24px)",
        scrollTrigger: {
          trigger: element,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      },
    );
  });
});
